<template>
	<div class="future-tracker">
		<div v-for="child in children" :key="`c${child.id}`" class="icon-wrapper">
			<svgicon
				v-if="child.ageGroup == 'Infant'"
				:original="true"
				name="hud/infant"
				class="small"
			></svgicon>
			<svgicon
				v-else-if="child.ageGroup == 'Child'"
				:original="true"
				name="hud/child"
			></svgicon>
			<svgicon
				v-else
				:original="true"
				name="hud/teenager"
				class="large"
			></svgicon>
		</div>
		<div v-if="married" class="icon-wrapper">
			<svgicon :original="true" name="hud/marriage"></svgicon>
		</div>
		<div v-for="num in numPets" :key="num" class="icon-wrapper">
			<svgicon :original="true" name="hud/pet"></svgicon>
		</div>
	</div>
</template>
<script>
import '../icons/hud';

export default {
	props: {
		children: {
			type: Array,
			default: null
		},
		married: {
			type: Boolean,
			default: false
		},
		numPets: {
			type: Number,
			default: 0
		}
	}
};
</script>
<style lang="scss" scoped>
.future-tracker {
	display: flex;
	height: 32px;
	background-color: $container-bgcolor;
	border-radius: 16px;
	align-items: center;
	padding: 8px 0;

	.icon-wrapper {
		padding: 0 16px;

		&:not(:last-child) {
			border-right: 1px solid #d7d7d7;
		}
		svg {
			height: 20px;
			width: 20px;

			&.small {
				height: 16px;
				width: 16px;
			}

			&.large {
				height: 24px;
				width: 16px;
			}
		}
	}
}
</style>
